(() => {
  'use strict';
  if (customElements.get('arcos-chef')) return;
  customElements.define('arcos-chef', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.cards = [...this.querySelectorAll('[data-offer]')];
      this.buttons = [...this.querySelectorAll('[data-filter]')];
      this.nav = this.querySelector('.sc-nav');
      this.header = document.querySelector('.header-section');
      this.measure = () => {
        const style = this.header && getComputedStyle(this.header);
        const sticky = style && ['sticky', 'fixed'].includes(style.position);
        const rect = this.header?.getBoundingClientRect();
        const offset = sticky ? Math.max(0, rect.bottom - Math.max(0, rect.top)) : 0;
        this.style.setProperty('--sc-header-offset', `${offset}px`);
        this.style.setProperty('--sc-nav-height', `${this.nav?.getBoundingClientRect().height || 0}px`);
      };
      this.buttons.forEach(button => button.addEventListener('click', () => {
        this.filter(button.dataset.filter);
        this.scrollToOffers();
      }, options));
      document.addEventListener('shopify:block:select', event => {
        if (this.cards.some(card => card.dataset.offer === event.detail?.blockId)) this.filter('all');
      }, options);
      window.addEventListener('resize', this.measure, options);
      window.addEventListener('scroll', this.measure, { ...options, passive: true });
      this.observer?.disconnect();
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(this.measure);
        if (this.header) this.observer.observe(this.header);
        if (this.nav) this.observer.observe(this.nav);
      }
      this.nav.hidden = this.cards.length < 2;
      this.filter('all');
      this.measure();
    }
    filter(value) {
      this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === value)));
      this.cards.forEach(card => { card.hidden = value !== 'all' && card.dataset.offer !== value; });
      const hasSeries = this.cards.some(card => card.classList.contains('sc-card') && !card.hidden);
      this.querySelector('.sc-series-heading').hidden = !hasSeries;
      this.querySelector('.sc-grid').hidden = !hasSeries;
    }
    scrollToOffers() {
      this.measure();
      requestAnimationFrame(() => this.querySelector('.sc-offers').scrollIntoView({
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'
      }));
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }
  });
})();
